import { omit } from "lodash";

import BaseChart, { ChartControls, ChartSettings } from "@/classes/BaseChart/index";
import { EXPLORE_MODULE, PLAN_MODULE } from "@/constants";
import { buildControlRows, buildFilterRows, buildFullDataTableRows, buildHeaderRows } from "@/helpers/csvExport";
import { widgetApi } from "@/router";
import { ChartDataRecord, Config } from "@/types/charts";
import { InputDictionary } from "@/types/common";
import { ContentWidget } from "@/types/layouts";

class ChartWithDataExport {
  declare settings: ChartSettings;
  declare responseData: ChartDataRecord[];
  declare config: Config;
  declare controls: ChartControls;
  declare widget: ContentWidget;
  protected metricsDictionary!: InputDictionary[];
  declare module: string;

  prepareDataForExport() {
    return this.responseData.map((item: Record<string, unknown>) => {
      return Object.keys(item).reduce((acc, key) => {
        const formatter = this.metricsDictionary.find((metric) => {
          return metric.value === key;
        })?.formatter;

        return {
          ...acc,
          [key]: formatter && typeof item[key] === "string" ? formatter(item[key] as string) : item[key],
        };
      }, {});
    });
  }

  exportData(isSingleChart = true): unknown[][] {
    if (this.module === EXPLORE_MODULE) {
      let body = widgetApi.getChartRequestBody(this as unknown as BaseChart);
      body = omit(body, ["dimension", "top", "statistic"]);
      const preparedData = this.prepareDataForExport();

      const csvContent = [];
      csvContent.push(...buildHeaderRows(this.widget.title));
      csvContent.push(...buildFilterRows(body, isSingleChart));
      csvContent.push(...buildControlRows(this.controls));
      csvContent.push(...buildFullDataTableRows(preparedData));

      return csvContent;
    }
    if (this.module === PLAN_MODULE) {
      const preparedData = this.prepareDataForExport();

      const csvContent = [];
      csvContent.push(...buildHeaderRows(this.widget.title));
      csvContent.push(...buildFullDataTableRows(preparedData, PLAN_MODULE));

      return csvContent;
    }
    return [];
  }
}

export default ChartWithDataExport;
